export default "/images/vendor/flag-icons/flags/1x1/er.svg?51a82d50a7e3633fe39cb927cfb37c80";